(() => {
  const TARGET_TEMPLATES = new Set([
    'collection-page-1',
    'collection-page-2',
    'collection-page-3',
    'harry-potter-lincensed',
    'storm-trooper-licensed',
    'licensed-landing-pages',
    'christmas_landing_page',
  ]);

  const LICENSED_TEMPLATES = new Set([
    'harry-potter-lincensed',
    'storm-trooper-licensed',
    'licensed-landing-pages',
    'christmas_landing_page',
  ]);

  const isTargetExperience = (experience) => {
    return Boolean(
      experience &&
      TARGET_TEMPLATES.has(experience.dataset.cardologyCollectionTemplate)
    );
  };

  const isLicensedExperience = (experience) =>
    Boolean(
      experience &&
      LICENSED_TEMPLATES.has(experience.dataset.cardologyCollectionTemplate)
    );

  const syncLicensedRatingStars = (root) => {
    if (!root) return;

    root.querySelectorAll('.rating-star').forEach((star) => {
      const rating = Number.parseFloat(star.style.getPropertyValue('--rating')) || 0;
      const decimal = Number.parseFloat(star.style.getPropertyValue('--rating-decimal')) || 0;
      const max = Number.parseFloat(star.style.getPropertyValue('--rating-max')) || 5;
      const percent = max > 0 ? Math.max(0, Math.min(100, ((rating + decimal) / max) * 100)) : 0;

      star.style.setProperty('--licensed-rating-percent', `${percent}%`);
      star.classList.add('cae-rating-star--licensed');
    });
  };

  const britishPersonalise = (value) => {
    if (!value || !value.includes('Personalize')) return value;

    return value
      .replace(/\bPersonalize\b/g, 'Personalise')
      .replace(/\bPERSONALIZE\b/g, 'PERSONALISE');
  };

  const normalisePersonaliseCopy = (root) => {
    if (!root) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    let currentNode;

    while ((currentNode = walker.nextNode())) {
      if (currentNode.nodeValue && currentNode.nodeValue.includes('Personalize')) {
        textNodes.push(currentNode);
      }
    }

    textNodes.forEach((node) => {
      node.nodeValue = britishPersonalise(node.nodeValue);
    });

    root.querySelectorAll('[aria-label], [title], input[value], button[value]').forEach((element) => {
      ['aria-label', 'title', 'value'].forEach((attribute) => {
        if (!element.hasAttribute(attribute)) return;

        const currentValue = element.getAttribute(attribute);
        const updatedValue = britishPersonalise(currentValue);

        if (updatedValue !== currentValue) {
          element.setAttribute(attribute, updatedValue);
        }
      });
    });
  };

  const enhanceCard = (item) => {
    const experience = item.closest('collection-ajax-experience');
    if (!isTargetExperience(experience)) return;

    const wrapper = item.querySelector(':scope > product-card.product-card-wrapper');
    if (!wrapper) return;

    wrapper.classList.add('cae-product-card');
    if (isLicensedExperience(experience)) syncLicensedRatingStars(item);
    normalisePersonaliseCopy(item);
  };

  const enhanceCollectionCards = (root = document) => {
    root.querySelectorAll('.cae-products [data-product-grid-item]').forEach((item) => enhanceCard(item));
  };

  document.addEventListener('collection:updated', () => enhanceCollectionCards());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceCollectionCards(), { once: true });
  } else {
    enhanceCollectionCards();
  }

  const observer = new MutationObserver((mutations) => {
    const shouldRefresh = mutations.some((mutation) => {
      return mutation.type === 'characterData' || mutation.addedNodes.length > 0;
    });

    if (shouldRefresh) enhanceCollectionCards();
  });

  const observe = () => {
    document.querySelectorAll('collection-ajax-experience').forEach((element) => {
      if (!isTargetExperience(element)) return;
      if (element.dataset.cardObserverBound === 'true') return;

      element.dataset.cardObserverBound = 'true';
      observer.observe(element, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      if (isLicensedExperience(element)) syncLicensedRatingStars(element);
      normalisePersonaliseCopy(element);
    });
  };

  observe();
  document.addEventListener('shopify:section:load', observe);
})();
